import React from 'react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { FormButtons } from '../FormButtons';
import { OptionSelector } from '../OptionSelector';
export const CarportRoofStep: React.FC = () => {
  const {
    formData,
    handleOptionSelect,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  return <FormStep title="Dakbedekking carport" description="Kies het type dakbedekking voor uw carport." isActive={true} data-id="element-830">
      <OptionSelector options={[{
      id: 'polycarbonaat-helder',
      name: 'Polycarbonaat helder',
      description: 'Lichtgewicht, voordelig en UV-bestendig',
      icon: <svg className="h-12 w-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-832">
                <path d="M3 9L12 3L21 9V21H3V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-833" />
                <path d="M3 21H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-834" />
              </svg>
    }, {
      id: 'polycarbonaat-opaal',
      name: 'Polycarbonaat opaal',
      description: 'Diffuus licht, minder warmte-doorlating',
      icon: <svg className="h-12 w-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-835">
                <path d="M3 9L12 3L21 9V21H3V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-836" />
                <path d="M3 21H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-837" />
              </svg>
    }, {
      id: 'glas-helder',
      name: 'Glas helder',
      description: 'Volledig transparant, maximale lichtinval',
      icon: <svg className="h-12 w-12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-838">
                <path d="M3 9L12 3L21 9V21H3V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-839" />
                <path d="M3 9L21 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-840" />
              </svg>
    }]} selectedOption={formData.carportRoof} onSelect={option => handleOptionSelect('carportRoof', option)} columns={3} data-id="element-831" />
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={!formData.carportRoof} data-id="element-841" />
    </FormStep>;
};